import moment from 'moment';
import { createUuid } from '../../helpers/General';
// initial state
// shape: [{ id, quantity }]
const state = () => ({
  toast: [],
  list: [],
  loaded: false,
  addNew: false,
  pagination: {
    total: 0,
    currentPage: 1,
    totalPageCount: 1,
  },
  take: 25,
  skip: 0,
  not_seen: 0,
})

// getters
const getters = {
  getConditions: (state) => (type) => {
    return state.list.filter(item => item.type == type);
  }
}

// actions
const actions = {
  async seen({ commit, state, rootState }, notifications) {
    await axios.post(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/notifications", { ids: notifications }).then(response => {
      commit("updateOrPush", ...response.data.data);
    })
  },
  async store({ commit, state, rootState }, data) {
    await axios.put(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/notifications", data).then(response => {
      commit("updateOrPush", response.data.data);
    })
  },
  async load({ commit, state, rootState }, page = 1) {
    let skip = state.take * (page - 1);
    return await axios.get(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/notifications",
      { params: { take: state.take, skip: skip } }).then(response => {
        commit("set", response.data.data);
        commit("pagination", _.get(response, "data.meta.pagination", { total: 0, take: state.take }))
        commit("not_seen", _.get(response, "data.meta.not_seen", 0))
      })
  },


}

// mutations
const mutations = {
  set(state, data) {
    state.list = data;
  },
  push(state, data) {
    state.list.push(data);
  },
  toast_push(state, data) {
    data.created_at = moment.now();
    state.toast.push(data);
  },
  unshift(state, data) {
    state.list.unshift(data);
  },
  splice(state, index) {
    state.list.splice(index, 1);
  },
  toast_splice(state, index) {
    state.toast.splice(index, 1);
  },
  toast_updateOrPush(state, data) {
    data.created_at = moment.now();
    var index = state.toast.findIndex(item => item.id == data.id);
    if (index > -1) {
      state.toast[index] = data;
    } else {
      state.toast.unshift(data);
    }
  },
  updateOrPush(state, data) {
    if(!data.id){
        data.id = createUuid();
    }
    var index = state.list.findIndex(item => item.id == data.id);
    if (index > -1) {
      state.list[index] = data;
    } else {
      state.list.unshift(data);
    }
  },
  not_seen(state, count) {
    state.not_seen = count;
  },
  pagination(state, object) {
    state.meta = object;
    state.skip = parseInt(object.skip)
    if (state.skip <= 0) {
      state.pagination.currentPage = 1;
    } else {
      state.pagination.currentPage = (state.skip / state.take) + 1;
    }
    state.pagination.totalPageCount = Math.ceil(state.meta.total / state.take);
    state.pagination.total = state.meta.total;
    state.pagination.pagesize = parseInt(state.meta.take);
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {
  }
}
